  export const parseTime = (time: string | Date): Date => {
    if (time instanceof Date) {
      return time;
    } else {
      const [hours, minutes] = time.split(':').map(Number);
      return new Date(0, 0, 0, hours, minutes);
    }
  };